<template>
    <div class="flex items-center mb-2 flex-nowrap w-full">
        <div class="w-1/5">
            <label class="vs-input--label mr-4">{{ label }}</label>
        </div>
        <div class="flex items-center w-4/5">
            <vx-input class="mr-4 w-full" v-model="from" disabled remove-validation-padding />
            <vx-action-icon class="mr-4" size="7" v-bind="iconAttrs" @click="update" />
            <vx-input
                class="mr-4 w-full"
                v-model="to_x"
                disabled
                remove-validation-padding
                hide-icon-validate
                v-bind="inputAttrs"
            />
        </div>
    </div>
</template>
<script>
import VxActionIcon from './VxActionIcon.vue'
import VxInput from './VxInput.vue'
export default {
    components: { VxInput, VxActionIcon },
    name: 'vx-property-merger',
    props: {
        from: {
            type: null
        },
        value: {
            type: null
        },
        label: {
            type: String
        }
    },
    data() {
        return {
            to_x: null,
            previousValue: null
        }
    },
    watch: {
        value: {
            handler: function (newTo) {
                if (newTo) {
                    if (!this.to_x && this.to_x !== this.newTo && !this.previousValue) {
                        this.setTo(newTo)
                    }
                }
            },
            immediate: true
        }
    },
    computed: {
        isModified() {
            return this.to_x != this.previousValue
        },
        iconAttrs() {
            if (
                (this.from == null || this.from == '') &&
                (this.to_x == null || this.to_x == '') &&
                this.previousValue == null
            ) {
                return {
                    icon: 'CheckSquareIcon',
                    color: 'success',
                    disabled: true
                }
            }
            if (!this.isModified && this.from != this.to_x) {
                return {
                    'icon': 'SquareIcon',
                    'hover-icon': 'ChevronsRightIcon',
                    'color': 'danger',
                    'hoverColor': 'warning',
                    'class': 'chevrons'
                }
            }
            if (this.isModified) {
                return {
                    icon: 'CheckSquareIcon',
                    hoverIcon: 'RotateCcwIcon',
                    color: 'success',
                    hoverColor: 'warning',
                    isButton: false
                }
            }
            return {
                icon: 'CheckSquareIcon',
                color: 'success',
                disabled: true
            }
        },
        inputAttrs() {
            if (
                (this.from == null || this.from == '') &&
                (this.to_x == null || this.to_x == '') &&
                this.previousValue == null
            ) {
                return {
                    color: 'success',
                    success: true
                }
            }
            if (!this.isModified && this.from != this.to_x) {
                return {
                    color: 'danger',
                    danger: true
                }
            }
            return {
                color: 'success',
                success: true
            }
        }
    },
    methods: {
        setTo(val) {
            this.to_x = val
            this.previousValue = this.deepCopy(val)
        },
        merge() {
            this.to_x = this.from
            if (!this.previousValue) {
                this.previousValue = null
            }
            this.$emit('input', this.to_x)
        },
        undoMerge() {
            this.to_x = this.deepCopy(this.previousValue)
            this.$emit('input', this.to_x)
        },
        update() {
            if (this.isModified) {
                return this.undoMerge()
            }
            if (!this.isModified) {
                return this.merge()
            }
        }
    },
    mounted() {
        //this.to_x = null
    },
    created() {}
}
</script>

<style lang="scss" scoped>
.chevrons {
    transition: transform 0.3s ease;
}
</style>
